(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ci-ceylon-cassia"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(el){
    if (!el || el.dataset.ciCcReady === '1') return;
    el.dataset.ciCcReady = '1';
    el.classList.add('is-js');
    el.classList.remove('is-armed', 'is-in');
    el.setAttribute('data-kind', 'ceylon');

    var buttons = [].slice.call(el.querySelectorAll('.ci-cc__toggle button'));
    var tds = [].slice.call(el.querySelectorAll('.ci-cc__table td'));
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var motion = el.classList.contains('ci-cc--motion') && !calm && !el.hasAttribute('data-design-mode');

    buttons.forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-kind') === 'ceylon'); });

    function show(kind){
      if (el.getAttribute('data-kind') === kind) return;
      el.setAttribute('data-kind', kind);
      buttons.forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-kind') === kind); });
      tds.forEach(function(td){ td.style.animation = 'none'; void td.offsetWidth; td.style.animation = ''; });
      if (kind === 'ceylon' && motion){
        el.classList.remove('is-in'); el.classList.add('is-armed');
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ el.classList.add('is-in'); }); });
      }
    }
    buttons.forEach(function(b){
      b.addEventListener('click', function(){ show(b.getAttribute('data-kind')); });
      b.addEventListener('keydown', function(e){
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = b.getAttribute('data-kind') === 'ceylon' ? 'cassia' : 'ceylon';
        show(next);
        el.querySelector('.ci-cc__toggle button[data-kind="' + next + '"]').focus();
      });
    });

    if (!motion || !('IntersectionObserver' in window)) return;
    el.classList.add('is-armed');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ el.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.3 });
    io.observe(el);
    /* safety: never leave the drawing hidden */
    setTimeout(function(){ el.classList.add('is-in'); }, 6000);
  }

  function boot(){ [].forEach.call(document.querySelectorAll('[data-ci-cc]'), init); }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }

  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[data-ci-cc]');
    if (el){ el.dataset.ciCcReady = ''; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ci-newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* after Shopify reloads the page with a result, bring the message into view and move focus to it */
  function reveal(root){
    var msg = root && root.querySelector('[data-ci-nl-msg]');
    if (!msg) return;
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    msg.scrollIntoView({ block: 'center', behavior: calm ? 'auto' : 'smooth' });
    try { msg.focus({ preventScroll: true }); } catch (e) { msg.focus(); }
  }
  function boot(){ [].forEach.call(document.querySelectorAll('[data-ci-nl]'), reveal); }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ci-organic-cert"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(el){
    if (!el || el.dataset.ciOrgReady === '1') return;
    el.dataset.ciOrgReady = '1';
    el.classList.remove('is-armed', 'is-in');

    if (!el.classList.contains('ci-org--motion')) return;
    if (el.hasAttribute('data-design-mode')) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    el.classList.add('is-armed');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ el.classList.add('is-in'); io.disconnect(); }
      });
    }, { threshold: 0.35 });
    io.observe(el);
    /* safety: never leave the content hidden */
    setTimeout(function(){ el.classList.add('is-in'); }, 6000);
  }

  function boot(){
    [].forEach.call(document.querySelectorAll('[data-ci-org]'), init);
  }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[data-ci-org]');
    if (el){ el.dataset.ciOrgReady = ''; init(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinnamon-isle-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ciReady === '1'){return;}
    root.dataset.ciReady = '1';
    var reveal = root.classList.contains('ci-rev');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cards = root.querySelectorAll('[data-card]');
    if(!reveal || reduce || !('IntersectionObserver' in window)){
      for(var j=0;j<cards.length;j++){ cards[j].classList.add('is-in'); }
      return;
    }
    for(var i=0;i<cards.length;i++){ cards[i].style.setProperty('--d', (i*0.09).toFixed(2)+'s'); }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, {threshold:0.15});
    for(var k=0;k<cards.length;k++){ io.observe(cards[k]); }
  }
  function boot(){
    var els = document.querySelectorAll('.ci-collection');
    for(var i=0;i<els.length;i++){ init(els[i]); }
  }
  if(document.readyState !== 'loading'){ boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.ci-collection');
    if(r){ r.dataset.ciReady=''; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinnamon-isle-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(cf){
    if(cf.dataset.ready==='1'){return;}
    cf.dataset.ready='1';
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var motion=(cf.getAttribute('data-motion')==='true') && !reduce;
    if(!motion){ cf.classList.add('no-motion','in'); return; }
    if(!('IntersectionObserver' in window)){ cf.classList.add('in'); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ cf.classList.add('in'); io.unobserve(cf); } });
    },{threshold:0.15});
    io.observe(cf);
  }
  function boot(){
    var els=document.querySelectorAll('.cf');
    for(var i=0;i<els.length;i++){ init(els[i]); }
  }
  if(document.readyState!=='loading'){ boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){
    var c=e.target.querySelector('.cf'); if(c){ c.dataset.ready=''; init(c); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinnamon-isle-origin-journey"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(stage){
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      stage.classList.add('ci-rm');
      return;
    }
    stage.classList.add('ci-js');

    var draw  = stage.querySelector('.ci-jm-path-draw');
    var base  = stage.querySelector('.ci-jm-path-base');
    var nodes = [].slice.call(stage.querySelectorAll('.ci-jm-node'));
    var close = stage.querySelector('.ci-jm-close');
    var n = nodes.length;
    if (!n || !draw || !base) return;
    var ticking = false;

    var LEN = draw.getTotalLength();
    draw.style.strokeDasharray = LEN;
    draw.style.strokeDashoffset = LEN;

    function clamp01(v){ return Math.min(1, Math.max(0, v)); }
    function easeSettle(t){ var c1=.9,c3=c1+1; return 1+c3*Math.pow(t-1,3)+c1*Math.pow(t-1,2); }

    /* stages spread evenly along the path */
    function stageT(i){
      if (n === 1) return .5;
      return .06 + i * (.88 / (n - 1));
    }

    function layout(){
      nodes.forEach(function(nd, i){
        var pt = base.getPointAtLength(LEN * stageT(i));
        nd.style.left = (pt.x / 1200 * 100) + '%';
        nd.style.top  = (pt.y / 640 * 100) + '%';
      });
    }

    function place(p){
      var drawP = clamp01(p / .86);
      draw.style.strokeDashoffset = LEN * (1 - drawP);

      nodes.forEach(function(nd, i){
        var local = clamp01((drawP - stageT(i)) / .09);
        var e = easeSettle(local);
        nd.style.opacity = local;
        nd.style.transform = 'translate(-50%,-50%) translateY(' + (14 * (1 - e)) + 'px) scale(' + (.86 + .14 * Math.min(1, e)) + ')';
      });

      if (close){
        var cf = clamp01((p - .88) / .12);
        var ce = easeSettle(cf);
        close.style.opacity = cf;
        close.style.transform = 'translateX(-50%) translateY(' + (10 * (1 - ce)) + 'px)';
        close.style.pointerEvents = cf > .6 ? 'auto' : 'none';
      }
    }

    function progress(){
      var r = stage.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (total <= 0) total = 1;
      return clamp01(-r.top / total);
    }
    function onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){ place(progress()); ticking = false; });
    }

    layout();
    place(0);
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', function(){ layout(); onScroll(); });
  }

  function boot(){
    [].forEach.call(document.querySelectorAll('[data-ci-journey]'), init);
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[data-ci-journey]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinnamon-isle-scroll-deck-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(stage){
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      stage.classList.add('ci-rm');
      return;
    }
    stage.classList.add('ci-js');

    var items  = [].slice.call(stage.querySelectorAll('.ci-sh-item'));
    var rail   = [].slice.call(stage.querySelectorAll('.ci-sh-rail button'));
    var finale = stage.querySelector('.ci-sh-finale');
    var n = items.length;
    if (!n) return;
    var ticking = false;
    var mob = window.matchMedia('(max-width: 880px)');

    var DECK_STEP_X = 3.6, DECK_SCALE = .08;
    var EXIT_X = -85, SPOT_SCALE = 1.06, TILT = -2.6;
    function centerX(){ return mob.matches ? 0 : -26; }

    function easeSettle(t){ var c1=.9,c3=c1+1; return 1+c3*Math.pow(t-1,3)+c1*Math.pow(t-1,2); }
    function easeInQ(t){ return t*t; }
    function easeOutQ(t){ return 1-(1-t)*(1-t); }
    function clamp01(v){ return Math.min(1, Math.max(0, v)); }

    function place(p){
      var CX = centerX();
      var active = Math.min(n-1, Math.floor(p*n));
      var la = p*n - active;
      var holdF = clamp01((la-.34)/.1) * (1 - clamp01((la-.66)/.14));

      items.forEach(function(el, i){
        var t = p*n - i;
        var x, s, o, z, rot=0, noteO=0, noteSh=10, shS=1, shO=.6;
        if (t <= 0){
          var q = Math.min(-t, 2.6);
          x = q * DECK_STEP_X;
          s = 1 - q * DECK_SCALE;
          o = (1 - Math.max(0, q-1) * .18) * (1 - .45*holdF);
          z = 100 - Math.round(q*10);
          shS = 1 - q*.08; shO = (.6 - q*.15) * (1 - .45*holdF);
        } else if (t < .42){
          var e1 = easeSettle(t/.42);
          x = CX * e1;
          s = 1 + (SPOT_SCALE-1) * Math.min(1,e1);
          o = 1; z = 200;
          rot = TILT * Math.sin(Math.PI * Math.min(1,(t/.42)));
          shS = 1 + .28*Math.sin(Math.PI*Math.min(1,(t/.42)));
          shO = .45 + .3*(1-Math.sin(Math.PI*Math.min(1,(t/.42))));
        } else if (t < .6){
          x = CX; s = SPOT_SCALE; o = 1; z = 200; rot = 0;
          var hold = (t-.42)/.18;
          noteO = Math.min(1, hold*2.2);
          noteSh = 10*(1-Math.min(1, hold*2.2));
          shS = .92; shO = .85;
        } else if (t < 1){
          var e2 = easeInQ((t-.6)/.4);
          x = CX + (EXIT_X-CX) * e2;
          s = SPOT_SCALE - .18*e2;
          o = 1 - easeOutQ((t-.6)/.4);
          z = 200;
          rot = TILT * 1.15 * e2;
          noteO = Math.max(0, 1 - e2*3); noteSh = 0;
          shS = 1 + .35*e2; shO = .7*(1-e2);
        } else { x = EXIT_X; s=.85; o=0; z=0; }

        el.style.transform = 'translate(-50%,-50%) translateX('+x+'vw) scale('+s+') rotate('+rot+'deg)';
        el.style.opacity = o;
        el.style.zIndex = z;
        var note = el.querySelector('.ci-sh-note');
        if (note){
          note.style.opacity = noteO;
          note.style.transform = 'translateX(-50%) translateY('+noteSh+'px)';
        }
        var sh = el.querySelector('.ci-sh-shadow');
        if (sh){ sh.style.transform='translateX(-50%) scaleX('+shS+')'; sh.style.opacity=shO; }
      });

      if (finale){
        var f = clamp01((p*n - (n - .35)) / .35);
        finale.style.opacity = f;
        finale.style.transform = 'translate(-50%,' + (-46 - 4*(1-f)) + '%)';
        finale.style.pointerEvents = f > .6 ? 'auto' : 'none';
      }
      rail.forEach(function(b,i){ b.classList.toggle('on', i===active); });
    }

    function progress(){
      var r = stage.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (total <= 0) total = 1;
      return { p: clamp01(-r.top / total), total: total, top: window.scrollY + r.top };
    }

    function onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){ place(progress().p); ticking = false; });
    }

    rail.forEach(function(btn){
      btn.addEventListener('click', function(){
        var i = parseInt(btn.getAttribute('data-goto'), 10);
        var pr = progress();
        window.scrollTo({ top: pr.top + pr.total * ((i + .5) / n), behavior: 'smooth' });
      });
    });

    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
    place(0);
    onScroll();
  }

  function boot(){
    [].forEach.call(document.querySelectorAll('[data-ci-scrollhero]'), init);
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[data-ci-scrollhero]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
